var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPAppointmentRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6424 1.72642L11.4368 7.53122C11.489 7.58106 11.5303 7.64106 11.5584 7.70752C11.5865 7.77398 11.6006 7.84548 11.6 7.91762C11.6002 8.0665 11.5415 8.20942 11.4368 8.31522C9.3408 10.36 7.3208 12.3336 5.3768 14.236C5.2768 14.3296 4.8768 14.5624 4.568 14.2168C4.2592 13.8704 4.4464 13.5688 4.568 13.444L10.2224 7.91762L4.8248 2.51042C4.628 2.23922 4.644 1.98882 4.8728 1.75922C5.1016 1.52962 5.3584 1.51842 5.6424 1.72642Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPAppointmentRightArrow);
export default __webpack_public_path__ + "static/media/p_appointment_right_arrow.b97cbf7ab04f61fef7784e6082d3791d.svg";
export { ForwardRef as ReactComponent };